<script setup lang="ts">
import { ProgressIndicator, ProgressRoot } from "reka-ui";

defineProps<{
  progress: number;
}>();
</script>

<template>
  <div class="flex items-center">
    <ProgressRoot
      :value="progress"
      class="bg-border-secondary w-full h-1 rounded-full overflow-hidden relative"
    >
      <ProgressIndicator
        class="bg-border-brand w-full h-full rounded-full transition-transform"
        :style="{ transform: `translateX(-${100 - progress}%)` }"
      />
    </ProgressRoot>
    <p class="text-sm ml-2 text-text-tertiary">{{ progress }}%</p>
  </div>
</template>
